/* tslint:disable */
/* eslint-disable */
/**
 * CarePlatform User Preferences API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Video background type
 * @export
 * @enum {string}
 */
export enum UserVideoBackgroundType {
    None = 'NONE',
    Blur = 'BLUR',
    File = 'FILE'
}

export function UserVideoBackgroundTypeFromJSON(json: any): UserVideoBackgroundType {
    return UserVideoBackgroundTypeFromJSONTyped(json, false);
}

export function UserVideoBackgroundTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserVideoBackgroundType {
    return json as UserVideoBackgroundType;
}

export function UserVideoBackgroundTypeToJSON(value?: UserVideoBackgroundType | null): any {
    return value as any;
}

